import { restResourceRequester } from "../rest-resource-requester";
import { CreatePartnerRequest } from "./create-partner/CreatePartnerRequest";
import { CreatePartnerResponse } from "./create-partner/CreatePartnerResponse";
import { GetPartnerRequest } from "./get-partner/GetPartnerRequest";
import { GetPartnerResponse } from "./get-partner/GetPartnerResponse";
import { UpdatePartnerRequest } from "./update-partner/UpdatePartnerRequest";
import { UpdatePartnerResponse } from "./update-partner/UpdatePartnerResponse";

interface PartnerRestResource {
  getPartner(request: GetPartnerRequest): Promise<GetPartnerResponse>;
  createPartner(request: CreatePartnerRequest): Promise<CreatePartnerResponse>;
  updatePartner(request: UpdatePartnerRequest): Promise<UpdatePartnerResponse>;
}

/**
 * Get /partner/{ptnrID}
 */
const getPartner = restResourceRequester<GetPartnerRequest, GetPartnerResponse>(
  "GET",
  (request) => `/partner/${request.ptnrId}`,
);

/**
 * PUT /partner
 */
const createPartner = restResourceRequester<
  CreatePartnerRequest,
  CreatePartnerResponse
>(
  "PUT",
  (_) => `/partner`,
  (request) => JSON.stringify(request),
);

/**
 * PUT /partner/{ptnrID}
 */
const updatePartner = restResourceRequester<
  UpdatePartnerRequest,
  UpdatePartnerResponse
>(
  "PUT",
  (request) => `/partner/${request.ptnrId}`,
  (request) => JSON.stringify(request),
);

export const PartnerRestResource: PartnerRestResource = {
  getPartner: getPartner,
  createPartner: createPartner,
  updatePartner: updatePartner,
};
